import React from 'react';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';

import Module from '../components/module';
import Title from '../components/title';
import Paragraph from '../components/paragraph';

import { CardSliderArrow, CardSliderDots } from '../components/card-slider';
import withDevice from '../components/withDevice';

class StatsCarousel extends Module {
    wrapperRef = React.createRef();

    filterSlides = (slides) => {
        const filtered = [];

        for (let set of slides) {
            const result = [];

            for (let stat of set) {
                if (stat.value !== '' && stat.desc !== '') {
                    result.push(stat);
                }
            }

            result.length && filtered.push(result);
        }

        return filtered;
    };

    applyStyleIfDesktop = (style) => {
        const {
            device: { isMobile, isTablet },
        } = this.props;

        return !isMobile && !isTablet ? style : undefined;
    };

    getWrapperWidth = () =>
        this.wrapperRef.current?.getBoundingClientRect().width;

    /*
    |--------------------------------------------------------------------------
    | LIFECYCLE
    |--------------------------------------------------------------------------
    */

    render = () => {
        const { title, desc, slides: s } = { ...this.props.config };
        const slides = s.length ? this.filterSlides(s) : false;
        const wrapperWidth = this.getWrapperWidth();

        return (
            <div
                className={this.applyStyleIfDesktop('-padded')}
                ref={this.wrapperRef}>
                <div className={this.applyStyleIfDesktop('-wrap')}>
                    <section className="stats-carousel">
                        <Title className="stats-carousel__title" level={1}>
                            {title}
                        </Title>
                        <Paragraph
                            className="stats-carousel__desc"
                            size="large">
                            {desc}
                        </Paragraph>
                        {slides && (
                            <CarouselProvider
                                className="stats-carousel__content"
                                infinite={true}
                                naturalSlideWidth={wrapperWidth}
                                isIntrinsicHeight={true}
                                totalSlides={slides.length}
                                visibleSlides={1}>
                                <Slider className="stats-carousel__content__items">
                                    {slides.map((slide, idx) => (
                                        <Slide key={idx} index={idx}>
                                            {slide.map((stat, idx) => (
                                                <div
                                                    className={`
                                                        stats-carousel__content__items__item
                                                        stats-carousel__content__items__item--${
                                                            idx + 1
                                                        }
                                                        stats-carousel__content__items__item--${
                                                            idx + 1
                                                        }--statscount-${
                                                        slide.length
                                                    }
                                                    `}
                                                    key={idx}>
                                                    <div
                                                        className={`
                                                            stats-carousel__content__items__item__valuebox 
                                                            stats-carousel__content__items__item__valuebox--${
                                                                idx + 1
                                                            }
                                                        `}>
                                                        <div className="stats-carousel__content__items__item__valuebox__value">
                                                            {stat.value}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`
                                                            stats-carousel__content__items__item__desc
                                                            stats-carousel__content__items__item__desc--${
                                                                idx === 1
                                                                    ? 'short'
                                                                    : 'normal'
                                                            }`}>
                                                        <Title level={5}>
                                                            {stat.desc}
                                                        </Title>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slide>
                                    ))}
                                </Slider>
                                <div className="stats-carousel__content__controls">
                                    <CardSliderArrow direction="prev" />
                                    <CardSliderDots
                                        className="stats-carousel__content__controls__dots"
                                        total={slides.length}
                                    />
                                    <CardSliderArrow direction="next" />
                                </div>
                            </CarouselProvider>
                        )}
                    </section>
                </div>
            </div>
        );
    };
}

export default withDevice(StatsCarousel);
